import { AppInput, AppPasswordInput, Button } from "components";
import AuthLayout from "layouts/AuthLayout";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { ApiService } from "services";
import styled from "styled-components";
import { Router } from "utils/route";

export default function Login() {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loader, setLoader] = useState(false);
  const { route } = Router();

  const loginAdmin = async () => {
    if (username && password) {
      setLoader(true);
      try {
        const data = await ApiService.loginUser({
          email: username,
          password: password,
        });
        console.log(data);
        setLoader(false);
        toast.success(data?.message);
        window.location = "/dashboard";
        localStorage.setItem("user_id", data?.data?.userData?.id);
      } catch (err) {
        console.log(err);
        setLoader(false);
        if (
          err?.response?.data?.data?.passwordChanged === "False" &&
          err?.response?.data?.data?.userId
        ) {
          console.log("redirect otp");
          localStorage.setItem("user_id", err?.response?.data?.data?.userId);
          toast(err?.response?.data?.message);

          route("/otp");
        } else {
          console.log("redirect login");
          if (err?.message === "It's not you, it's us. Try again later.") {
          } else if (err?.message === "Network Error") {
            toast.error('An error occurred, Check connectivity"');
          } else {
            toast.error(err?.response?.data?.message || err?.message);
          }
        }
      }
    }
  };
  return (
    <div>
      <AuthLayout
        submit={(e) => {
          e.preventDefault();
          console.log("eeee");
          loginAdmin();
        }}
        title="Welcome to Payarena Exchange Monitoring System"
      >
        <AppInput
          onChange={(e) => {
            setUsername(e.target.value);
          }}
          placeholder="Email"
          type="email"
        />
        <AppPasswordInput
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="Password"
        />
        <Button loading={loader} disabled={loader} placeholder="Proceed" />
        <Forgotpassword
          onClick={() => {
            route("/send-mail");
          }}
        >
          Forgot Password
        </Forgotpassword>
      </AuthLayout>
    </div>
  );
}

const Forgotpassword = styled.p`
  display: flex;
  justify-content: center;
  cursor: pointer;
`;
